import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import jardaction from '../../context/action/report/jardaction.js'
import Jardtable from "./jardtable";
import expense from "../../context/action/report/expense";
import Expensetable from "./expensetable";
import sellreportaction from "../../context/action/report/sellreportaction";
import Selltable from "./selltable";
import companyaction from "../../context/action/report/companyaction";
import Companytable from "./companytable";
import brokeaction from "../../context/action/report/brokeaction";
import Broketable from "./broketable";
import summaryaction from "../../context/action/report/summaryaction";
import Summarytable from "./summarytable";
import Itemselltable from "./itemselltable";
import itemsellaction from "../../context/action/report/itemsellaction";
import customeraction from "../../context/action/report/customeraction.js";
import Customertable from "./customertable.jsx";
import serviceaction from "../../context/action/report/serviceaction.js";
import Servicetable from "./servicetable.jsx";
const Report = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  const [from, setfrom] = useState();
  const [to, setto] = useState();
  const [company_id, setcompany_id] = useState();
  const [customer_id, setcustomer_id] = useState();
  const [service_id, setservice_id] = useState();
  const [casher_id, setcasher_id] = useState();
  const [category_id, setcategory_id] = useState();
  const [barcode, setbarcode] = useState();

  const [type, settype] = useState();
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);
  const [error5, seterror5] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">ڕاپۆرت</h1>
          <p className="text-sm text-slate-400 mt-0.5">-</p>
        </div>
      </div>

      {/* Filter Section */}
      {/* Add New Expense Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
        <div className="w-full">
            <label 
              className={
                "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
            >
              کاشێر
            </label>
            <select
              className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              value={casher_id}
              onChange={(val) => setcasher_id(val.target.value)}
            >
              <option value="">کاشێر</option>
              {initState.user.map((lis) => (
                <option key={lis.user_id} value={lis.user_id}>
                  {lis.user_name}
                </option>
              ))}
            </select>
          </div>

          {/* From Date */}
          <div className="w-full">
            <label
              className={
                error
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }

            >
              لە بەرواری
            </label>
            <input
              type="date"
              className={
                error
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }

              value={from}
              onChange={(val) => setfrom(val.target.value)}
              onFocus={() => seterror(false)}
            />
          </div>

          {/* To Date */}
          <div className="w-full">
            <label
              className={
                error1
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }

            >
              بۆ بەرواری
            </label>
            <input
              type="date"
              className={
                error1
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              value={to}
              onChange={(val) => setto(val.target.value)}
              onFocus={() => seterror1(false)}
            />
          </div>
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-3 items-end">
          {/* Category Select */}
          <div className="w-full">
            <label
              className={
                error2
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }

            >
              کاتیگۆری
            </label>
            <select
              className={
                error2
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }

              value={category_id}
              onChange={(val) => {
                setcategory_id(val.target.value);
                seterror2(false);
              }}
            >
              <option value="">کاتیگۆری</option>
              {initState.category.map((lis) => (
                <option key={lis.category_id} value={lis.category_id}>
                  {lis.category_name}
                </option>
              ))}
            </select>
          </div>

          {/* Service Select */}
          <div className="w-full">
            <label
              className={
                error5
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }

            >
              خزمەتگوزاری
            </label>
            <select
              className={
                error5
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              value={service_id}
              onChange={(val) => {
                setservice_id(val.target.value);
                seterror5(false);
              }}
            >
              <option value="">خزمەتگوزاری</option>
              {initState.service.map((lis) => (
                <option key={lis.service_id} value={lis.service_id}>
                  {lis.service_name}
                </option>
              ))}
            </select>
          </div>

          {/* Barcode Input */}
          <div className="w-full">
            <label
              className={
                error3
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }

            >
              باڕکۆد
            </label>
            <input
              type="number"
              className={
                error3
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              onClick={(val)=>{val.target.select()}}
              value={barcode}
              onChange={(val) => setbarcode(val.target.value)}
              onFocus={() => seterror3(false)}
            />
          </div>
        </div>
      </div>

      {/* Report Cards - First Row */}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {/* Add your existing report cards here with updated styling */}
        {/* Example of one card: */}
        <div
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            jardaction(category_id)(recaller)(setrecaller)(initDispatch)(clear)(settype);
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              جەردی مەخزەن
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              کاتیگۆری
            </div>
          </div>
        </div>
        <div
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            if (!from || from == "") {
              seterror(true);
              return false;
            }
            if (!to || to == "") {
              seterror1(true);
              return false;
            }
            expense(from, to)(recaller)(setrecaller)(initDispatch)(clear)(settype);
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              خەرجی
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              لە بەرواری , بۆ بەرواری{" "}
            </div>
          </div>
        </div>
        <div
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            if (!from || from == "") {
              seterror(true);
              return false;
            }
            if (!to || to == "") {
              seterror1(true);
              return false;
            }
            brokeaction(from, to)(recaller)(setrecaller)(initDispatch)(clear)(settype);
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              خەسار
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              {" "}
              لە بەرواری , بۆ بەرواری
            </div>
          </div>
        </div>
        <div
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            if (!from || from == "") {
              seterror(true);
              return false;
            }
            if (!to || to == "") {
              seterror1(true);
              return false;
            }
            sellreportaction(from, to, casher_id)(recaller)(setrecaller)(initDispatch)(clear)(settype);
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              فرۆش
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              {" "}
              کاشێر , لە بەرواری , بۆ بەرواری
            </div>
          </div>
        </div>
      </div>
      {/* Report Cards - Second Row */}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {/* Item Sales Card */}
        <div 
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            if (!from || from == "") {
              seterror(true);
              return false;
            }
            if (!to || to == "") {
              seterror1(true);
              return false;
            }
            if (!barcode || barcode == "") {
              seterror3(true);
              return false;
            }
            itemsellaction(from,to,barcode)(recaller)(setrecaller)(initDispatch)(clear)(settype)
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              فرۆشی کاڵا
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              باڕکۆد , لە بەرواری , بۆ بەرواری
            </div>
          </div>
        </div>

        {/* Services Card */}
        <div 
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            if (!from || from == "") {
              seterror(true);
              return false;
            }
            if (!to || to == "") {
              seterror1(true);
              return false;
            }
            if(!service_id||service_id==''){
              seterror5(true);
              return false;
            }
            serviceaction(from,to,service_id)(recaller)(setrecaller)(initDispatch)(clear)(settype)
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              خزمەتگوزاری
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              خزمەتگوزاری , لە بەرواری , بۆ بەرواری
            </div>
          </div>
        </div>

        {/* Summary Card */}
        <div 
          className="cursor-pointer rounded-lg bg-white shadow-md 
            transition-all duration-200 hover:shadow-lg"
          onClick={() => {
            if (!from || from == "") {
              seterror(true);
              return false;
            }
            if (!to || to == "") {
              seterror1(true);
              return false;
            }
            summaryaction(from,to)(recaller)(setrecaller)(initDispatch)(clear)(settype)
          }}
        >
          <div className="p-4 sm:p-6">
            <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
              پوختە
            </h5>
            <div className="pt-4 border-t text-sm text-gray-600">
              لە بەرواری , بۆ بەرواری
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8">
        {type=='jard'?<Jardtable />:type=='expense'?<Expensetable />:type=='sell'?<Selltable />:type=='company'?<Companytable />:type=='broken'?<Broketable />:type=='summary'?<Summarytable />:type=='itemsellreport'?<Itemselltable />:type=='customer'?<Customertable />:type=='servicereport'?<Servicetable />:null}
      </div>
    </div>
  );
};

export default Report;
